import { action } from "typesafe-actions";
import {
  OPEN_MENU,
  CLOSE_MENU,
  TOGGLE_MENU,
  SET_ACTIVE,
  TOGGLE_SECONDARY_MENU,
  TOGGLE_HOVER,
  SET_SUB_ACTIVE,
  OPEN_SECONDARY_MENU,
  CLOSE_SECONDARY_MENU,
  TOGGLE_FLYOUT_PINNED,
  TOGGLE_SECONDARY_AVAILABLE,
} from "./leftMenuActionTypes";

export const openLeftMenu = () => action(OPEN_MENU);
export const closeLeftMenu = () => action(CLOSE_MENU);
export const toggleMenu = () => action(TOGGLE_MENU);
export const toggleHover = () => action(TOGGLE_HOVER);
export const toggleSecondaryMenu = () => action(TOGGLE_SECONDARY_MENU);
export const openSecondaryMenu = () => action(OPEN_SECONDARY_MENU);
export const closeSecondaryMenu = () => action(CLOSE_SECONDARY_MENU);
export const setActive = (key: string) => action(SET_ACTIVE, { key });
export const setSubActive = (key: string) => action(SET_SUB_ACTIVE, { key });
export const toggleFlyoutPinned = () => action(TOGGLE_FLYOUT_PINNED);
export const toggleSecondaryAvailable = () => action(TOGGLE_SECONDARY_AVAILABLE);
